import moment from "moment";

export function getLocalDateTime(date, offsetStr) {
  const offset = offsetStr || date.getTimezoneOffset();
  const fullLocalDateTime = moment(date)
    .utc()
    .utcOffset(offset)
    .format("DD MMM YYYY hh:mm A z");
  const localDate = moment(date)
    .utc()
    .utcOffset(offset)
    .format("YYYY-MM-DD");
  const localDateInDDMMMYYYY = moment(date)
    .utc()
    .utcOffset(offset)
    .format("DD MMM YYYY");
  const localDateMoment = moment(date)
    .utc()
    .utcOffset(offset);
  return {
    basicLocalDate: localDateInDDMMMYYYY,
    fullLocalDateTime: fullLocalDateTime,
    localDate: localDate,
    localDateMoment: localDateMoment
  };
}
